export default __webpack_public_path__ + "/dist/images/cibecco.d655e7c00c441446478ce2f0e6ef9aac.png";